import { Switch, TableColumnsType, Popconfirm } from "antd";
import moment from "moment";

import { IVersion } from "@types";
import { permissions } from "@/router";
import { checkPermission } from "@/utils";
import { dateFormat } from "@/constants";
import { LoadingOutlined } from "@ant-design/icons";
import { BsTrash3 } from "react-icons/bs";
import { IoMdDownload } from "react-icons/io";
import { MdOutlineFileDownload } from "react-icons/md";

// export const getVersionsColumns = ({
//   handleActive,
//   currentId,
//   download,
//   handleDelete,
//   isDeleting,
//   payrollVersionId,
// }: {
//   handleActive: (id: number) => Promise<void>;
//   currentId: null | number;
//   download: (id?: number) => void;
//   handleDelete: (id: number) => Promise<void>;
//   isDeleting: boolean;
//   payrollVersionId: MutableRefObject<number | null>;
// }): TableColumnsType<any> => [
//   {
//     title: "created at",
//     dataIndex: "created_at",
//     key: "created_at",
//     width: 240,
//     align: "center",
//     render: (date: string) => <div>{moment(date).format(dateFormat)}</div>,
//   },
//   {
//     title: "updated at",
//     dataIndex: "updated_at",
//     key: "updated_at",
//     width: 240,
//     align: "center",
//     render: (date: string) => <div>{moment(date).format(dateFormat)}</div>,
//   },

//   ...(!checkPermission(permissions.CREATE_INTERNAL_PAYROLL)
//     ? []
//     : ([
//         {
//           title: "Active",
//           key: "active",
//           width: 240,
//           align: "center",
//           render: (version: IVersion) => (
//             <Switch
//               onChange={checked => {
//                 if (!checked) return;
//                 handleActive(version?.id);
//               }}
//               checked={
//                 currentId === version?.id ||
//                 (version?.is_active === "TRUE" &&
//                   currentId === version?.id)
//               }
//               defaultChecked={version?.is_active === "TRUE"}
//             />
//           ),
//         },
//       ] as any)),

//   // Flexible empty space before Actions
//   {
//     title: "",
//     key: "spacer",
//   },

//   {
//     title: "Actions",
//     key: "action",
//     width: 220,
//     align: "center",
//     render: (version: IVersion) => (
//       <div className="flex items-center justify-center gap-3">
//         <div
//           onClick={() => download(version?.id)}
//           className="table__action__btn table__action__btn--download"
//         >
//           Download
//         </div>

//         {checkPermission(permissions.DELETE_INTERNAL_PAYROLL) &&
//           currentId !== version?.id &&
//           version?.is_active !== "TRUE" && (
//             <div
//               onClick={() => {
//                 if (!isDeleting) {
//                   handleDelete(version?.id);
//                 }
//               }}
//               className="table__action__btn table__action__btn--delete"
//             >
//               {isDeleting &&
//               version?.id === payrollVersionId.current ? (
//                 <LoadingOutlined color="#B62424" className="spinner" />
//               ) : (
//                 <>
//                   <BsTrash3 className="text-white textx mr-1" />
//                   Delete
//                 </>
//               )}
//             </div>
//           )}
//       </div>
//     ),
//   },
// ];


export const getVersionsColumns = ({
  handleActive,
  currentId,
  download,
  handleDelete,
  isDeleting,
  isDownloading,
  payrollVersionId,
  downloadingVersionId,
}: {
  handleActive: (id: number) => Promise<void>;
  currentId: null | number;
  download: (id?: number) => Promise<void>;
  handleDelete: (id: number) => Promise<void>;
  isDeleting: boolean;
  isDownloading: boolean;
  payrollVersionId: MutableRefObject<number | null>;
  downloadingVersionId: MutableRefObject<number | null>;
}): TableColumnsType<any> => [
  {
    title: "created at",
    dataIndex: "created_at",
    key: "created_at",
    width: 240,
    align: "center",
    render: (date: string) => <div>{moment(date).format(dateFormat)}</div>,
  },
  {
    title: "updated at",
    dataIndex: "updated_at",
    key: "updated_at",
    width: 240,
    align: "center",
    render: (date: string) => <div>{moment(date).format(dateFormat)}</div>,
  },

  ...(!checkPermission(permissions.CREATE_INTERNAL_PAYROLL)
    ? []
    : ([
        {
          title: "Active",
          key: "active",
          width: 140,
          align: "center",
          render: (version: IVersion) => (
            <Switch
              onChange={checked => {
                if (!checked) return;
                handleActive(version?.id);
              }}
              checked={currentId === version?.id}
              defaultChecked={version?.is_active === "TRUE"}
            />
          ),
        },
      ] as any)),

  {
    title: "",
    key: "spacer",
  },

  {
    title: "Actions",
    key: "action",
    width: 250,
    align: "center",

    render: (version: IVersion) => (
      <div className="flex items-center justify-center gap-3">
        <div
          onClick={() => {
            if (!isDownloading) {
              download(version?.id);
            }
          }}
          className="table__action__btn table__action__btn--download"
        >
          {isDownloading &&
          downloadingVersionId.current === version?.id ? (
            <LoadingOutlined className="spinner" />
          ) : (
            <>
              <MdOutlineFileDownload className="text-white text-xl mr-1" />
              Download
            </>
          )}
        </div>

        {checkPermission(permissions.DELETE_INTERNAL_PAYROLL) &&
          currentId !== version?.id &&
          version?.is_active !== "TRUE" && (
            <div
              onClick={() => {
                if (!isDeleting) {
                  handleDelete(version?.id);
                }
              }}
              className="table__action__btn table__action__btn--delete"
            >
              {isDeleting &&
              payrollVersionId.current === version?.id ? (
                <LoadingOutlined className="spinner" />
              ) : (
                <>
                  <BsTrash3 className="text-white text-xl mr-1" />
                  Delete
                </>
              )}
            </div>
          )}
      </div>
    ),
  },
];